module.exports = __webpack_public_path__ + "img/76022.edc599f9.svg";